import { Component, OnInit } from '@angular/core';
import {DcService} from '../../../services/dc.service';
import {ModalService} from '../../../services/modal.service';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {ShepherdService} from 'angular-shepherd';
import {SenderService} from '../../../services/sender.service';
import {InterfaceService} from '../../../services/interface.service';
import {defaultStepOptions} from '../../../tour/data';
import Step from 'shepherd.js/src/types/step';
import {ToursService} from '../../../services/tours.service';

@Component({
  selector: 'app-text-variations-shepherd',
  templateUrl: './text-variations-shepherd.component.html',
  styleUrls: ['./text-variations-shepherd.component.scss']
})
export class TextVariationsShepherdComponent implements OnInit {
  constructor(
    private toursService: ToursService,
    private dcService: DcService,
    public modalService: ModalService,
    public allMessengersService: AllMessengersService,
    public notifierWrapService: NotifierWrapService,
    private shepherdService: ShepherdService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
  ) {
  }
  next(): void {
    if (this.shepherdService.isActive) {
      this.shepherdService.next();
    }
  }
  ngOnInit(): void {
    this.toursService.startVariationsTour$.subscribe((timeout) => {
      if (this.toursService.tourTextVariationsNotShow) {
        return;
      }
      this.closeModal();
      this.shepherdService.confirmCancelMessage = 'При рассылке важно использовать несколько вариантов текстов, это снизит возможность блокировки аккаунтов.';
      this.shepherdService.defaultStepOptions = defaultStepOptions;
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      this.shepherdService.addSteps([
        this.introStep,
        this.twoStep,
        // this.threStep,
      ]);

      setTimeout(() => {
        this.shepherdService.start();
      }, timeout);
    });
  }
  closeModal() {
    if (this.modalService.bsModalRef) {
      this.modalService.bsModalRef.hide();
    }
  }
  get buttons(): Step.StepOptionsButton[] {
    const array = [
      {
        action: () => {
          this.toursService.tourTextVariationsNotShow = true;
          return true;
        },
        text: 'Я знаю',
        classes: 'btn btn-link',
      },
      {
        action: () => {
          this.toursService.tourTextVariationsNotShow = true;
          return true;
        },
        text: 'Пропустить',
        classes: 'btn btn-link',
      },
      {
        action: () => {
          this.closeModal();
          this.senderService.openSenderChat();
          return this.next();
        },
        text: 'Научить вас?',
        classes: 'btn btn-primary',
      }
    ];
    return array;
  }
  get introStep(): Step.StepOptions {
    return {
      id: 'variations-start',
      attachTo: {
        element: '',
        on: 'top'
      },
      buttons: this.buttons,
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Легкое добавление вариантов текста.',
      text: ['При рассылке важно использовать несколько вариантов текстов, это снизит возможность блокировки аккаунтов. Вам поможет ИИ их сгенерировать и улучшить.'],
    };
  }
  get twoStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'variants-start-button',
      attachTo: {
        element: '#add-variant-text',
        on: 'top'
      },
      buttons: [
        {
          action() {
            return this.complete();
          },
          classes: 'btn btn-link',
          text: 'Закрыть'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Нажмите кнопку',
      text: ['Ваш главный текст будет взят за основу для генерации дополнительного текста рассылки с помощью искуственного интеллекта. После генерации нажимайте кнопку "+", до достижения желаемого кол-ва вариантов, количество зависит от ко-ва получателей, рекомендуем от 5 вариантов.'],
    };
  }
  get threStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'variants-end-button',
      buttons: [
        {
          action() {
            return this.complete();
          },
          classes: 'btn btn-link',
          text: 'Закрыть'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Нажмите кнопку',
      text: ['После генерации нажимайте кнопку "+", до достижения желаемого кол-ва вариантов, количество зависит от ко-ва получателей, рекомендуем от 5 вариантов.'],
    };
  }
}
